import { LoadingButton } from "@mui/lab";
import { Alert, Box, Button, TextField, Typography } from "@mui/material";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLocationsThunk,
  locationSelector,
} from "store/reducers/inventory/locationSlice";
import { fillingPersonStockTransactionThunk } from "store/reducers/inventory/stock/fillingPersonStockSlice";
import * as yup from "yup";

const ReturnFillingPersonStock = ({ open, handleClose, stock }) => {
  const dispatch = useDispatch();
  const validation = yup.object({
    qty: yup.number().required().positive().min(1).max(stock.qty),
  });
  const formik = useFormik({
    initialValues: {
      qty: stock.qty,
      product_variant: stock.product_variant,
      in_or_out: "ret",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      //   console.log(data);
      dispatch(
        fillingPersonStockTransactionThunk({
          stock,
          data: { ...data, location: data.location.id },
        })
      );
    },
    enableReinitialize: true,
  });
  const state = useSelector(
    (state) => state.fillingPersonStock.fillingPersonStockTransactionStatus
  );
  useEffect(() => {
    dispatch(getLocationsThunk());
  }, []);
  const locations = useSelector(locationSelector.selectAll);
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Return stock"
    >
      <Box padding={2}>
        <Typography variant="h6" color="text.secondary">
          You are about to return the following product
        </Typography>
        <Typography variant="h5" color="text.secondary">
          {stock.name}
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ marginTop: 2 }}>
          <TextField
            fullWidth
            name="qty"
            value={formik.values.qty}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.qty)}
            helperText={formik.errors.qty}
            type="number"
            sx={{ mb: 2 }}
          />
          <AutoCompleteListFormik
            items={locations}
            name="name"
            label="Choose location"
            formik={formik}
            formikName="location"
            required={true}
          />
          {state?.error === "post" && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred , {state?.errorMessage}
            </Alert>
          )}

          {state?.success === "post" && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            sx={{ mt: 2 }}
            variant="outlined"
            type="submit"
            loading={state?.loading === "post"}
          >
            Submit
          </LoadingButton>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default ReturnFillingPersonStock;
